import { render, staticRenderFns } from "./URN.vue?vue&type=template&id=34e4e7ee&scoped=true"
import script from "./URN.vue?vue&type=script&lang=js"
export * from "./URN.vue?vue&type=script&lang=js"
import style0 from "./URN.vue?vue&type=style&index=0&id=34e4e7ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34e4e7ee",
  null
  
)

export default component.exports